import { useUser } from '@clerk/clerk-react';
import { css } from '@styled-system/css';
import { stack } from '@styled-system/patterns';
import { type FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/shared/components/ui/Button';
import { Separator } from '@/shared/components/ui/Separator';

export const AccountTab: FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  const containerStyles = stack({
    direction: 'column',
    gap: 'md',
  });

  const itemContainerStyles = stack({
    direction: 'column',
    gap: 'sm',
  });

  const itemStyles = stack({
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  });

  const labelStyles = css({
    fontSize: 'sm',
    fontWeight: 'medium',
    color: 'font.primary',
  });

  const separatorStyles = css({
    w: '90%',
    alignSelf: 'end',
  });

  const handleManageUserClick = () => {
    navigate('/manage-user-account');
  };

  return (
    <div className={containerStyles}>
      <div className={itemContainerStyles}>
        <div className={itemStyles}>
          <span className={labelStyles}>{user?.primaryEmailAddress?.emailAddress ?? ''}</span>
          <Button handleClick={handleManageUserClick}>Gérer</Button>
        </div>
        <Separator className={separatorStyles} />
      </div>
    </div>
  );
};
